<template>
  <div class="resorts">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <template v-if="systemSettings.length > 0">
            <div class="col-md-4 mt-3" v-for="(setting, index) in systemSettings" :key="index">
              <div class="box setting-box">
                <div class="row">
                  <div class="col-md-12">
                    <p class="heading">{{ setting.showName }}</p>
                  </div>
                </div>
                <div class="row p-3">
                  <div class="col-md-12">
                    <template v-if="setting.fieldSettings.type === 'checkbox'">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input 
                            type="checkbox" 
                            class="form-check-input" 
                            :name="setting.name" 
                            :id="setting.id" 
                            v-model="setting.value"/>
                          {{ setting.fieldSettings.placeholder }}
                        </label>
                      </div>
                    </template>
                    <template v-else-if="setting.fieldSettings.type === 'select'">
                      <div class="form-group">
                        <v-select
                          label="label"
                          index="value"
                          :id="setting.id"
                          :placeholder="setting.fieldSettings.placeholder"
                          v-model="setting.value"
                          :options="setting.fieldSettings.options"
                      />
                      </div>
                    </template>
                    <template v-else-if="setting.fieldSettings.type === 'textarea'">
                      <div class="form-group">
                        <textarea class="form-control" :name="setting.name" :id="setting.id" style="resize: none; height: 150px;" v-model="setting.value"></textarea>
                      </div>
                    </template>
                    <template v-else>
                      <input 
                        :type="setting.fieldSettings.type" 
                        :class="setting.fieldSettings.class" 
                        v-model="setting.value" 
                        :name="setting.name"/>
                    </template>
                  </div>
                </div>
                <div class="row p-3">
                  <div class="col-md-12" style="display: flex; justify-content: end;">
                    <button class="button mt-2" @click="updateSetting(setting)">Update</button>
                  </div>
                </div>

                <div class="wrap">
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "SystemSetting",
  components: {
  },
  created() {
    this.fetchSettings();
  },
  computed: {
    systemSettings() {
      let settingObj = [];
      if (this.settings.length > 0) {
        settingObj = this.settings.map(item => {
          let value = null;
          if(item.field_setting.type === 'checkbox') {
            value = item.value === '1' || item.value === true || item.value === 1 || item.value === 'yes' || item.value === 'Yes' ? 1 : 0;
          } else {
            value = item.value;
          }
          return {
            id: item.id,
            name: item.name,
            showName: this.createFriendlyName(item.name),
            value,
            fieldSettings: item.field_setting
          };
        });
      }    
      return settingObj;
    }
  },
  data() {
    return {
      settings: [],
    };
  },
  methods: {
    fetchSettings() {
      this.$store.dispatch("setLoadStatus");
      fetch(this.$api + "settings/system", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: localStorage.getItem("token")
        }
      })
        .then(res => res.json())
        .then(response => {
          if (response.status) {
            this.settings = response.data;
          }
        })
        .finally(() => {
          this.$store.dispatch("setLoadStatus");
        });
    },
    updateSetting(setting) {
      this.$store.dispatch("setLoadStatus");
      
      // Create a clean object with only the properties needed for the API
      const cleanSetting = {
        id: setting.id,
        name: setting.name,
        value: setting.value
      };
      
      fetch(this.$api + "settings/system/" + setting.id, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: localStorage.getItem("token")
        },
        body: JSON.stringify(cleanSetting)
      })
        .then(res => res.json())
        .then(response => {
          if (response.success) {
            this.$notify({
              type: "success",
              title: response.message
            });
            this.fetchSettings();
          } else {
            this.$notify({
              type: "error",
              title: response.message
            });
          }
        })
        .catch(err => {
          this.$notify({
            type: "error",
            title: err.message
          });
        })
        .finally(() => {
          this.$store.dispatch("setLoadStatus");
        });
    },
    createFriendlyName(name) {
      return name.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());
    },
  }
};
</script>
<style scoped>
.heading {
  font-size: 28px;
  font-weight: bolder;
  padding: 10px;
}
</style>
